import React from "react";
import { Link, graphql } from "gatsby";
import { Div, Image, Text } from "atomize";

import Layout from "../components/common/layout";
import Header from "../components/common/Header";

import SEO from "../components/seo";
import Footer from "../components/common/Footer";

import WebsiteContainer from "../components/common/WebsiteContainer";
import CustomContainer from "../components/common/CustomContainer";

import PricingQA from "../components/pricing/PricingQA";
import PricingDemo from "../components/pricing/PricingDemo";
import PricingSlider from "../components/pricing/PricingSlider";
import PricingSolvedSlider from "../components/pricing/PricingSolvedSlider";
import PricingHero from "../components/pricing/PricingHero";
import PricingPoints from "../components/pricing/PricingPoints";
import PricingReviews from "../components/pricing/PricingReviews";

const Pricing = ({ data }) => {
  const hero = {
    headerGradientText: data.contentfulPricingPage.headerTitle,
    headerHeading: data.contentfulPricingPage.headerDescription,
    headerText: data.contentfulPricingPage.headerText,
    headerBtnLink:
      data.contentfulPricingPage.pricingPoints.getStartedButton.link,
    headerBtnText:
      data.contentfulPricingPage.pricingPoints.getStartedButton.text,
    headerFooterText: data.contentfulPricingPage.pricingPoints.footerText.text,
  };

  return (
    <Layout>
      <SEO
        seo={data.contentfulPricingPage.seo}
        url="https://trend.io/pricing"
      />
      <Header headerFixed={true} data={{ contentfulJson: data.headerJson }} />
      <PricingReviews />
      <PricingHero
        content={hero}
        modalContent={data.contentfulPricingPage.heroActionModal}
      />
      <PricingPoints
        points={data.contentfulPricingPage.pricingPoints.pricingPoints}
        campaign={data.contentfulPricingPage.pricingPoints.campaigns}
        footer={data.contentfulPricingPage.pricingPoints.footerText}
        features={data.contentfulPricingPage.pricingPoints.features}
        getStarted={data.contentfulPricingPage.pricingPoints.getStartedButton}
        scheduleDemoButton={
          data.contentfulPricingPage.pricingPoints.scheduleDemoButton
        }
      />

      <Text d="none" tag="h1">
        Pricing
      </Text>

      <PricingSlider
        title={data.contentfulPricingPage.brandHeaderTitle}
        items={data.contentfulPricingPage.brands}
      />
      {/* <PricingVideo
      title={data.contentfulPricingPage.videoHeaderTitle}
      video={data.contentfulPricingPage.video}
      image={data.contentfulPricingPage.videoImage}
    /> */}
      <Div
        m={{
          t: { xs: "5.75rem", md: "8.125rem" },
          b: { xs: "3.375rem", md: "4.625rem" },
        }}
        className="pricing-hero"
      >
        <WebsiteContainer>
          <CustomContainer>
            <Text
              className="heading"
              textSize={{ xs: "title3", md: "display4" }}
              textWeight="bold"
              textColor="#3B3B3B"
            >
              {data.contentfulPricingPage.pricingMidSectionText}
            </Text>
          </CustomContainer>
        </WebsiteContainer>
      </Div>
      <PricingSolvedSlider
        title={data.contentfulPricingPage.solvedCasesHeaderTitle}
        items={data.contentfulPricingPage.solvedCases}
      />
      {/* <PricingCost /> */}
      <Div id={"pricing-faq"}>
        <PricingQA
          title={data.contentfulPricingPage.questionAnswerHeaderTitle}
          items={data.contentfulPricingPage.questionAnswer}
        />
      </Div>
      <PricingDemo
        title={data.contentfulPricingPage.footerTitle}
        link={data.contentfulPricingPage.footerLink}
        link2={data.contentfulPricingPage.footerLink2}
        button1={data.contentfulPricingPage.footerButton1}
        button2={data.contentfulPricingPage.footerButton2}
      />
      <Footer
        contentfulFooter={data.contentfulFooter}
        contentfulGlobalConfig={data.contentfulGlobalConfig}
      />
    </Layout>
  );
};

export const query = graphql`
  query($slug: String!) {
    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }
    contentfulGlobalConfig {
      footerForm {
        footerForm
      }
    }
    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }
    contentfulPricingPage(slug: { eq: $slug }) {
      headerTitle
      headerDescription
      headerText
      brandHeaderTitle
      standardCostPerCredit
      vipCostPerCredit
      pricingMidSectionText
      brands {
        image {
          file {
            url
          }
          description
        }
        logo {
          file {
            url
          }
          description
        }
      }
      videoHeaderTitle
      videoImage {
        file {
          url
        }
        description
      }
      video {
        file {
          url
        }
        description
      }
      pricingPoints {
        features {
          creator {
            title
            text
          }
          software {
            title
            text
          }
        }
        getStartedButton {
          link
          text
        }
        scheduleDemoButton {
          link
          text
        }
        footerText {
          text
          reviewText
          image1
          image2
          imageLink1
          imageLink2
        }
        pricingPoints {
          heading
          points {
            image
            point
          }
        }
      }
      solvedCasesHeaderTitle
      solvedCases {
        title
        description {
          description
        }
        image {
          file {
            url
          }
          description
        }
      }
      questionAnswerHeaderTitle
      questionAnswer {
        id
        question {
          id
          question
        }
        answer {
          id
          answer
        }
      }
      footerTitle
      footerLink
      footerLink2
      footerButton1
      footerButton2
      seo {
        ...SeoFragment
      }
      pricingPage2Seo {
        ...SeoFragment
      }
      heroActionModal {
        json
      }
    }
  }
`;

export default Pricing;